import React, { useEffect, useState, useRef } from "react";
import "./StockScreen.css";

const STOCK_API = "/api/stock";

export default function StockScreen({ goHome }) {

const [view,setView] = useState("summary"); 


const [date,setDate] = useState(
 new Date().toISOString().slice(0,10)
);

const [stockList,setStockList] = useState([]);
const [search,setSearch] = useState("");

const [listType,setListType] = useState("");

const tableRef = useRef(null);

useEffect(()=>{
 if(view==="summary") loadStock();
},[date,view]);

async function loadStock(){
 const res = await fetch(`${STOCK_API}?date=${date}`);
 const data = await res.json();
 setStockList(data);
}



const filteredList = stockList.filter(item =>
 item.itemName.toLowerCase().includes(search.toLowerCase())
);

const totalOpening = stockList.reduce(
 (sum,item)=>sum+Number(item.openingQty||0),0
);

const totalPurchase = stockList.reduce(
 (sum,item)=>sum+Number(item.purchaseQty||0),0
);

const totalSales = stockList.reduce(
 (sum,item)=>sum+Number(item.salesQty||0),0
);

const totalStock = stockList.reduce(
 (sum,item)=>sum+Number(item.stockQty||0),0
);
const itemsInStock = stockList.filter(
i => Number(i.stockQty) > 0
);

const purchasedToday = stockList.filter(
i => Number(i.purchaseQty) > 0
);

const soldToday = stockList.filter(
i => Number(i.salesQty) > 0
);

const noMovement = stockList.filter(
i => Number(i.purchaseQty) === 0 &&
     Number(i.salesQty) === 0
);
function scrollToItem(id){
 const row = document.getElementById(`row-${id}`);
 row?.scrollIntoView({behavior:"smooth",block:"center"});
}

return(

<div className="stock-root">

<div className="stock-title">STOCK</div>

{/* ================= SUMMARY ================= */}

{view==="summary" && (

<div className="stock-content">

{/* LEFT SIDE */}

<div className="stock-left">

<div className="stock-card">

<div className="stock-card-header">
Stock As On Date
</div>

<div className="stock-header-row">

<div className="stock-field">

<label>Select Date</label>

<input
type="date"
className="stock-input"
value={date}
onChange={e=>setDate(e.target.value)}
/>

</div>

</div>

{/* DESKTOP TABLE */}

<div className="stock-table-wrap" ref={tableRef}>

<table className="stock-table">

<thead>

<tr>
<th>Item</th>
<th>HSN</th>
<th>Opening</th>
<th>Purchase</th>
<th>Sales</th>
<th>Stock</th>
</tr>

</thead>

<tbody>

{stockList.map(item=>(
<tr
key={item.itemId}
id={`row-${item.itemId}`}
>

<td>{item.itemName}</td>
<td>{item.hsnCode}</td>

<td className="num">
{Number(item.openingQty||0)} {item.unitType}
</td>

<td className="num">
{Number(item.purchaseQty||0)} {item.unitType}
</td>

<td className="num">
{Number(item.salesQty||0)} {item.unitType}
</td>

<td className="num">
{Number(item.stockQty||0)} {item.unitType}
</td>

</tr>
))}

<tr className="stock-total-row">

<td colSpan="2"><b>Total</b></td>

<td className="num">
<b>{totalOpening.toFixed(2)}</b>
</td>

<td className="num">
<b>{totalPurchase.toFixed(2)}</b>
</td>

<td className="num">
<b>{totalSales.toFixed(2)}</b>
</td>

<td className="num">
<b>{totalStock.toFixed(2)}</b>
</td>

</tr>

</tbody>

</table>

</div>

<button
  onClick={goHome}

>
  EXIT
</button>
{/* MOBILE STOCK LIST */}

<div className="stock-mobile-card-wrap">

<div className="stock-mobile-list">

{filteredList.map(item => (

<div
key={item.itemId}
className="stock-mobile-card"
>

<div className="stock-mobile-title">
{item.itemName}
</div>

<div className="stock-mobile-row">
<span>Opening</span>
<span>{item.openingQty} {item.unitType}</span>
</div>

<div className="stock-mobile-row">
<span>Purchase</span>
<span>{item.purchaseQty} {item.unitType}</span>
</div>

<div className="stock-mobile-row">
<span>Sales</span>
<span>{item.salesQty} {item.unitType}</span>
</div>

<div className="stock-mobile-row stock-mobile-total">
<span>Stock</span>
<span>{item.stockQty} {item.unitType} ▶</span>
</div>

</div>

))}

</div>

</div>


</div>

</div>

{/* RIGHT LIST */}

<div className="stock-right">

<div className="stock-right-title">
Stock List
</div>

<input
className="stock-search"
placeholder="Search item..."
value={search}
onChange={e=>setSearch(e.target.value)}
/>

<div className="stock-list">

{filteredList.map(item=>(
<div
key={item.itemId}
className="stock-list-row"
onClick={()=>scrollToItem(item.itemId)}
>

<div>{item.itemName}</div>

<div>
Stock : {Number(item.stockQty||0)} {item.unitType}
</div>

</div>
))}

</div>

</div>

</div>

)}


{view==="overview" && (

<div className="overview-root">

<h3>Stock Overview</h3>
<div className="stock-mobile-card-wrap">
<div className="overview-card">

<div>
Items In Stock
</div>

<div>
{itemsInStock.length} items
</div>

<button onClick={()=>{
setListType("stock");
setView("list");
}}>
VIEW
</button>

</div>

<div className="overview-card">

<div>
Items Purchased Today
</div>

<div>
{purchasedToday.length} items
</div>

<button onClick={()=>{
setListType("purchase");
setView("list");
}}>
VIEW
</button>

</div>

<div className="overview-card">

<div>
Items Sold Today
</div>

<div>
{soldToday.length} items
</div>

<button onClick={()=>{
setListType("sales");
setView("list");
}}>
VIEW
</button>

</div>

<div className="overview-card">

<div>
No Movement Items
</div>

<div>
{noMovement.length} items
</div>

<button onClick={()=>{
setListType("nomove");
setView("list");
}}>
VIEW
</button>

</div>


</div>
</div>
)}

{view==="list" && (

<div className="list-root">

<h3>

{listType==="stock" && "Items In Stock"}
{listType==="purchase" && "Purchased Today"}
{listType==="sales" && "Sales Today"}
{listType==="nomove" && "No Movement Items"}

</h3>
<div className="stock-mobile-card-wrap">
<div className="list-box">

{(listType==="stock" ? itemsInStock :
  listType==="purchase" ? purchasedToday :
  listType==="sales" ? soldToday :
  noMovement
).map(item=>(

<div key={item.itemId} className="list-row">

<div>{item.itemName}</div>

<div>

{listType==="stock" &&
`Stock : ${item.stockQty} ${item.unitType}`}

{listType==="purchase" &&
`Purchase : ${item.purchaseQty} ${item.unitType}`}

{listType==="sales" &&
`Sales : ${item.salesQty} ${item.unitType}`}

</div>

</div>

))}

</div>



</div>
</div>
)}

<div className="stock-mobile-bottom">

{view === "summary" && (
<>
<button
className="stock-tab"
onClick={()=>setView("overview")}
>
Stock Overview
</button>

<button
className="stock-tab"
onClick={goHome}
>
Exit
</button>
</>
)}

{view === "overview" && (
<button
className="stock-tab active"
onClick={()=>setView("summary")}
>
Back
</button>
)}

{view === "list" && (
<button
className="stock-tab active"
onClick={()=>setView("overview")}
>
Back
</button>
)}

</div>
</div>

);
}